import Anchor from './Anchor'
import AnchorLink from './AnchorLink'

export { AnchorProps } from './Anchor'
export { AnchorLinkProps } from './AnchorLink'

Anchor.Link = AnchorLink
export default Anchor



// WEBPACK FOOTER //
// ./components/anchor/index.jsx